export { watch, type FSWatcher } from 'chokidar'
export { EventEmitter } from 'events'
